<template>
  <div class="iotDetailsDialog-container">
    <div class="top">
      <div class="top-id">{{ ebikeId }}</div>
    </div>

    <div class="title-style">
      <el-divider></el-divider>
      <div class="title">{{ $t('bike.name255') }}</div>
      <el-divider></el-divider>
    </div>

    <el-form class="iotDetailsDialog-form" label-position="top" style="width:100%;">
      <el-row class="el-row2">
        <el-col :span="8"><el-form-item :label="$t('bike.name256')">{{ iotDetails.username || '-' }}</el-form-item></el-col>
        <el-col :span="8"><el-form-item :label="$t('bike.name257')">{{ iotDetails.connected ? $t('bike.name45') : $t('bike.name113') }}</el-form-item></el-col>
        <el-col :span="8"><el-form-item :label="$t('bike.name258')">{{ iotDetails.port || '-' }}</el-form-item></el-col>
      </el-row>
      <el-row class="el-row2">
        <el-col :span="8"><el-form-item :label="$t('bike.name259')">{{ iotDetails.node || '-' }}</el-form-item></el-col>
        <el-col :span="8"><el-form-item :label="$t('bike.name260')">{{ iotDetails.ip_address || '-' }}</el-form-item></el-col>
        <el-col :span="8"><el-form-item :label="$t('bike.name261')">{{ iotDetails.keepalive || '-' }}</el-form-item></el-col>
      </el-row>
      <el-row class="el-row2">
        <el-col :span="8"><el-form-item :label="$t('bike.name262')">{{ iotDetails.created_at || '-' }}</el-form-item></el-col>
        <el-col :span="8"><el-form-item :label="$t('bike.name263')">{{ iotDetails.expiry_interval || '-' }}</el-form-item></el-col>
        <el-col :span="8"><el-form-item :label="$t('bike.name264')">{{ iotDetails.connected_at || '-' }}</el-form-item></el-col>
      </el-row>
      <el-row class="el-row2">
        <el-col :span="8"><el-form-item :label="$t('bike.name265')">{{ iotDetails.send_pkt || '-' }}</el-form-item></el-col>
        <el-col :span="8"><el-form-item :label="$t('bike.name266')">{{ iotDetails.recv_pkt || '-' }}</el-form-item></el-col>
        <el-col :span="8"><el-form-item :label="$t('bike.name267')">{{ iotDetails.recv_cnt || '-' }}</el-form-item></el-col>
      </el-row>
      <el-row class="el-row2">
        <el-col :span="8"><el-form-item :label="$t('bike.name268')">{{ iotDetails.max_awaiting_rel || '-' }}</el-form-item></el-col>
        <el-col :span="8"><el-form-item :label="$t('bike.name269')">{{ iotDetails.max_inflight || '-' }}</el-form-item></el-col>
      </el-row>
    </el-form>

    <div class="title-style">
      <el-divider></el-divider>
      <div class="title">{{ $t('bike.name270') }}</div>
      <el-divider></el-divider>
    </div>
    <el-table :data="subscribeList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }">
      <el-table-column label="node" prop="node"></el-table-column>
      <el-table-column label="clientid" prop="clientid"></el-table-column>
      <el-table-column label="qos" prop="qos"></el-table-column>
      <el-table-column label="topic" prop="topic"></el-table-column>
    </el-table>

    <div class="title-style">
      <el-divider></el-divider>
      <div class="title">{{ $t('bike.name271') }}</div>
      <el-divider></el-divider>
    </div>
    <div class="date-picker">
      <el-date-picker
        v-model="searchTime"
        type="datetimerange"
        value-format="yyyy-MM-dd HH:mm:ss"
        :range-separator="$t('public.name9')"
        :start-placeholder="$t('public.name10')"
        :end-placeholder="$t('public.name11')"
      >
      </el-date-picker>
      <el-button type="primary" size="small" @click="getIotLog" class="search-bt" :loading="loading">{{ $t('public.name3') }}</el-button>
    </div>
    <div class="iot-log" v-html="iotLogInfo"></div>
  </div>
</template>

<script>
import { findIotStatusInfo, findIotSubscribeTopic, findIotCmdLog } from '@/api/bike.js'

export default {
  props: {
    ebikeId: {
      type: String,
      default: () => ''
    }
  },
  data () {
    return {
      iotDetails: {},
      subscribeList: [],
      searchTime: null,
      iotLogInfo: '',
      loading: false,
      timer: null
    }
  },
  mounted () {
    this.getIOTDetails()
    this.timer = setInterval(this.getIOTDetails, 10000)
  },
  beforeDestroy () {
    this.clearTimer()
  },
  methods: {
    getIOTDetails () {
      if (!this.ebikeId) {
        return
      }
      findIotStatusInfo({ ebikeId: this.ebikeId })
        .then((res) => {
          if (res.code === 200) {
            const info = res.data.iotStatusInfo
            this.iotDetails = Array.isArray(info) && info.length > 0 ? info[0] : (info || {})
          }
        })
        .catch(() => {})
      findIotSubscribeTopic({ ebikeId: this.ebikeId })
        .then((res) => {
          if (res.code === 200) {
            this.subscribeList = res.data.topic || []
          }
        })
        .catch(() => {
          this.subscribeList = []
        })
    },
    getIotLog () {
      if (!this.searchTime || !this.ebikeId) {
        return
      }
      this.loading = true
      // 车辆开发人员查看原始运行日志：picker 选的墙钟直接当 UTC 检索条件，不做任何时区换算
      const [startTime, endTime] = this.searchTime
      findIotCmdLog({
        startTime,
        endTime,
        ebikeId: this.ebikeId,
        wrap: '</br>'
      }).then((res) => {
        this.iotLogInfo = res.data.iotLogInfo || this.$t('public.name39')
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    clearTimer () {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    close () {
      this.clearTimer()
      this.iotDetails = {}
      this.subscribeList = []
      this.iotLogInfo = ''
      this.searchTime = null
    }
  }
}
</script>

<style lang="scss">
.iotDetailsDialog-container {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;

  .iotDetailsDialog-form.el-form--label-top {
    width: 100%;
    max-width: 100%;
    min-width: 0;

    .el-form-item {
      display: block;
      margin-bottom: 14px;

      .el-form-item__label {
        display: block;
        float: none;
        text-align: left;
        padding: 0 0 6px;
        line-height: 1.4 !important;
        white-space: normal;
        word-break: break-word;
        width: 100% !important;
        color: #909399;
      }

      .el-form-item__content {
        display: block;
        float: none;
        line-height: 1.5 !important;
        margin-left: 0 !important;
        width: 100%;
        max-width: 100%;
        word-break: break-word;
        color: #303133;
      }
    }
  }

  .el-row2 {
    margin-left: 0 !important;
    margin-right: 0 !important;
    width: 100%;
    max-width: 100%;

    &::before,
    &::after {
      display: none;
    }

    > .el-col {
      min-width: 0;
      box-sizing: border-box;
      padding-right: 16px;
    }

    .el-form-item {
      margin-bottom: 14px;
    }
  }

  .el-table {
    width: 100% !important;
  }
}
</style>

<style lang="scss" scoped>
.iotDetailsDialog-container {
  display: flex;
  flex-direction: column;
  width: 100%;

  .top {
    width: 100%;
    margin-bottom: 8px;

    .top-id {
      word-break: break-all;
      font-weight: 500;
      font-size: 15px;
    }
  }

  .title-style {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      flex-shrink: 0;
      padding: 0 12px;
      text-align: center;
      white-space: nowrap;
    }

    .el-divider {
      flex: 1;
      margin: 12px 0;
    }
  }

  .date-picker {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
  }

  .iot-log {
    margin: 15px 0;
    word-break: break-word;
  }
}
</style>
